import React from 'react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
  const words = {
    pageTitle: {
      pl: 'Strona nie istnieje!',
      en: 'Page Not Found!',
    },
    pageContent: {
      pl: 'Strona, której szukasz nie istnieje!',
      en: 'Sorry but the page you are looking for does not exist.',
    },
    orderCardLink: {
      pl: 'Zamów swoją kartę',
      en: 'Order your card',
    },
  };

  // Sprawdzenie języka zapisanego w localStorage lub innym mechanizmie
  const language = localStorage.getItem('language') || 'pl';

  return (
    <div translate="no">
      <div className="vertical-center">
        <div className="container">
          <div id="notfound" className="text-center">
            <h1>😮</h1>
            <h2>{words.pageTitle[language]}</h2>
            <p>{words.pageContent[language]}</p>
            <Link to="/">{words.orderCardLink[language]}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
